export default {
  title: 'Products',
  subTitle: 'Lorem ipsum dolor',
  totalPages: '{{offset}}-{{totalPages}} of {{total}}',
  archivingReasonTitle: 'Specify reason for archiving',
  archivingReasonDescription: 'Please provide a reason for archiving the selected record(s). You can restore '
        + 'them anytime.',
  archiveDetails: 'Archived record details',
  editInformation: 'Edit Information',
  addNewInputProduct: 'Add New Product',
  editInputProduct: 'Edit Product',
  fields: {
    productName: 'Product Name',
    productCode: 'Internal Code',
    uniqueIdentifier: 'Product System Unique Identifier',
    profitCentreId: 'Profit Centre ID',
    supplier: 'Supplier Name',
    supplierId: 'Supplier System Unique Identifier',
    addSupplier: 'Add supplier',
    suppliedBy: 'Supplied by',
    manufacturedBy: 'Manufactured by',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    volume: 'Volume Qty',
    volumeUnit: 'Volume Unit',
    equityControl: 'Equity Control %',
    expectedGrowth: 'Expected Growth / Decline %',
    relianceNatural: 'Reliance on \'Free\' Natural Resources',
    relianceSocial: 'Reliance on \'Free\' Social Resources',
    placeholderNatural: 'Select natural resources',
    placeholderSocial: 'Select social resources',
    rating: 'Criticality Rating',
    circularityPercentage: '% Circularity from Downstream Waste',
    suppliersTier1: 'Suppliers Tier 1 Total Cost of Sales Spend',
    suppliersTier1InPercentage: 'Suppliers Tier 1 % of Total Cost of Sales Spend',
    actions: 'Actions',
    upstreamTier: 'Upstream Tier',
    startDate: 'FY Start Date',
    endDate: 'FY End Date',
    expectedGrowthDecline: 'Expected Growth / Decline %',
    profitCentre: 'Profit Centre',
    valueChain: 'Value Chain Position',
    productCategory: 'Product Category',
    productType: 'Product Type',
  },
  selectionsGeneral: 'General',
  selectionsSourcing: 'Sourcing',
  selectionsFinancials: 'Financials',
  addSupplierConnection: 'Add connection',
  noSupplierConnections: 'No connections yet. Use the plus button to add one.',
  noSourcesInScope: 'No sources available. Output products are sourced from the balance sheet assets '
        + 'of the profit centres they belong to — set those on the Financials tab first.',
};
